export default __webpack_public_path__ + "static/realWorldImg4-b3c907ce9daa8f56ef14c683d5c4158b.png";